import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7b9949b0")

_pushScopeId("data-v-7b9949b0")
const _hoisted_1 = {
  key: 0,
  id: "order"
}
const _hoisted_2 = { class: "order-detail" }
const _hoisted_3 = { class: "order-number" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Order ")
const _hoisted_5 = { class: "order-summary" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h2", null, "Order Status", -1)
const _hoisted_7 = { class: "order-status-row" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h2", null, "Customer Status", -1)
const _hoisted_9 = { class: "customer-status-row" }
const _hoisted_10 = { class: "customer-status customer-status-arrived" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Arrived ")
const _hoisted_12 = { class: "customer-status-text" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "customer-description"
}
const _hoisted_15 = { class: "customer-spot" }
const _hoisted_16 = { class: "customer-status-text" }
const _hoisted_17 = {
  key: 1,
  class: "customer-status"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("h2", null, "Order Details", -1)
const _hoisted_19 = { class: "order-details" }
const _hoisted_20 = {
  key: 0,
  class: "ingredients"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("strong", null, "customized //", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_23 = {
  key: 0,
  class: "ingredients"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("strong", null, "quantity:", -1)
const _hoisted_25 = {
  key: 1,
  id: "order"
}
const _hoisted_26 = { class: "order-detail" }
const _hoisted_27 = /*#__PURE__*/_createVNode("h1", { id: "page-title" }, " No order found ", -1)
const _hoisted_28 = { class: "order-customer" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Back to the list of active orders ")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_action_button = _resolveComponent("action-button")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_messages_order = _resolveComponent("messages-order")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, { "scroll-y": true }, {
        default: _withId(() => [
          (_ctx.order)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("header", null, [
                    _createVNode("div", null, [
                      _createVNode("h1", {
                        id: "page-title",
                        textContent: _ctx.customerName
                      }, null, 8, ["textContent"]),
                      _createVNode("p", _hoisted_3, [
                        _hoisted_4,
                        _createVNode("span", { innerHTML: _ctx.orderNumberFormatted }, null, 8, ["innerHTML"])
                      ]),
                      (_ctx.order.orderDetails.client_platform)
                        ? (_openBlock(), _createBlock("p", {
                            key: 0,
                            textContent: _ctx.order.orderDetails.client_platform,
                            class: "order-platform"
                          }, null, 8, ["textContent"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_5, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.itemsSummary, (count) => {
                        return (_openBlock(), _createBlock("div", {
                          key: count,
                          innerHTML: count
                        }, null, 8, ["innerHTML"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]),
                  _createVNode("section", null, [
                    _hoisted_6,
                    _createVNode("div", _hoisted_7, [
                      _createVNode("p", {
                        textContent: _ctx.orderStatusFormatted,
                        class: ["order-status", { ready: _ctx.isReady }]
                      }, null, 10, ["textContent"]),
                      (_ctx.canConfirmHandoff)
                        ? (_openBlock(), _createBlock(_component_action_button, {
                            key: 0,
                            class: "confirm-handoff",
                            id: "confirm-handoff",
                            text: "Confirm Handoff",
                            "is-large": true,
                            checkmark: true,
                            onClick: _withModifiers(_ctx.confirmHandoff, ["stop"])
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("section", null, [
                    _hoisted_8,
                    _createVNode("div", _hoisted_9, [
                      (_ctx.hasArrived)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createVNode("p", _hoisted_10, [
                              _hoisted_11,
                              (
                                            _ctx.order.orderDetails
                                                .acknowledge_arrival
                                        )
                                ? (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 0,
                                    icon: "/assets/icons/checkmark.svg"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_12, [
                              (_ctx.isCurbside)
                                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                                    (_ctx.order.orderDetails.arrival_status.location)
                                      ? (_openBlock(), _createBlock("p", _hoisted_14, " Spot #" + _toDisplayString(_ctx.order.orderDetails.arrival_status.location), 1))
                                      : _createCommentVNode("", true),
                                    _createVNode("p", _hoisted_15, _toDisplayString(_ctx.order.orderDetails.arrival_status.vehicle.color) + " " + _toDisplayString(_ctx.order.orderDetails.arrival_status.vehicle.make) + " " + _toDisplayString(_ctx.order.orderDetails.arrival_status.vehicle.type), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("div", _hoisted_16, [
                                _createVNode("p", {
                                  class: "customer-description",
                                  textContent: 
                                                _ctx.order.orderDetails
                                                    .arrival_status.details
                                            
                                }, null, 8, ["textContent"])
                              ])
                            ])
                          ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createBlock("p", _hoisted_17, " Not Yet Arrived "))
                    ])
                  ]),
                  _createVNode("section", null, [
                    _hoisted_18,
                    _createVNode("ul", _hoisted_19, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pies, (pie) => {
                        return (_openBlock(), _createBlock("li", {
                          key: pie.pieOfOrder
                        }, [
                          _createVNode("h3", {
                            textContent: pie.name
                          }, null, 8, ["textContent"]),
                          (pie.modifiedHit)
                            ? (_openBlock(), _createBlock("p", _hoisted_20, [
                                _hoisted_21,
                                _createTextVNode(" " + _toDisplayString(pie?.hitIngredients?.join(', ') ?? ''), 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(pie.ingredients, (customization) => {
                            return (_openBlock(), _createBlock("p", {
                              key: customization.groupName,
                              class: "ingredients"
                            }, [
                              _createVNode("strong", {
                                textContent: customization.groupName
                              }, null, 8, ["textContent"]),
                              _hoisted_22,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(customization.items, (item) => {
                                return (_openBlock(), _createBlock(_Fragment, {
                                  key: item.name
                                }, [
                                  (item.important)
                                    ? (_openBlock(), _createBlock("strong", {
                                        key: 0,
                                        textContent: item.name
                                      }, null, 8, ["textContent"]))
                                    : (_openBlock(), _createBlock("span", {
                                        key: 1,
                                        textContent: item.name
                                      }, null, 8, ["textContent"]))
                                ], 64 /* STABLE_FRAGMENT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.extras, (extra, key) => {
                        return (_openBlock(), _createBlock("li", { key: key }, [
                          _createVNode("h3", {
                            textContent: extra.name
                          }, null, 8, ["textContent"]),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(extra.modifiers, (modifier, key) => {
                            return (_openBlock(), _createBlock("p", {
                              key: key,
                              class: "ingredients"
                            }, [
                              _createVNode("strong", {
                                textContent: modifier.description
                              }, null, 8, ["textContent"])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          (extra.quantity > 1)
                            ? (_openBlock(), _createBlock("p", _hoisted_23, [
                                _hoisted_24,
                                _createTextVNode(" " + _toDisplayString(extra.quantity), 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]),
                (_ctx.configs.featureFlags().showOrderMessages && _ctx.showOrderGuestMessage)
                  ? (_openBlock(), _createBlock(_component_messages_order, {
                      key: 0,
                      "order-id": _ctx.order.orderDetails.orderID,
                      "reference-number": _ctx.order.orderDetails.orderKey,
                      "customer-name": _ctx.customerName
                    }, null, 8, ["order-id", "reference-number", "customer-name"]))
                  : _createCommentVNode("", true)
              ]))
            : (!_ctx.isLoading)
              ? (_openBlock(), _createBlock("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, [
                    _createVNode("header", null, [
                      _createVNode("div", null, [
                        _hoisted_27,
                        _createVNode("p", _hoisted_28, [
                          _createVNode(_component_ion_button, {
                            fill: "clear",
                            class: "back-link",
                            "router-link": "/orders",
                            "router-direction": "back"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.chevronBackSharp }, null, 8, ["icon"]),
                              _hoisted_29
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})